//////////////////////////////////////////////////////
// Scroll to on click when needed on page
//////////////////////////////////////////////////////

function scrollToSection() {
  const destinations = document.querySelectorAll(".scrollTo-destination");
  const scrollToBtn = document.querySelectorAll(".scrollTo-btn");

  scrollToBtn.forEach((btn, i) => {
    btn.addEventListener("click", () => {
      window.scrollTo({
        top: destinations[i].offsetTop - 100,
        behavior: "smooth",
      });
    });
  });

  // btn.addEventListener("click", () => {
  //   scrollTo({
  //     top: destination.offsetTop,
  //     behavior: "smooth",
  //   });
  // });
}

// exports function to be used on other scripts
export default scrollToSection;
